"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEPARATOR = exports.PREFIX = void 0;
exports.PREFIX = 'APP';
exports.SEPARATOR = '::';